import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3237e84d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-section fullwidth-slider bg-dark light-content" }
const _hoisted_2 = { class: "container fixed-height-medium d-flex align-items-end" }
const _hoisted_3 = { class: "home-content wow fadeInUpShort" }
const _hoisted_4 = { class: "text-shadow hs-line-3 mb-10" }
const _hoisted_5 = {
  class: "text-shadow hs-line-6 wow fadeInUpShort",
  "data-wow-delay": ".1s"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "news-title text-shadow mb-70 mb-xs-40" }

import WithLoadingPromise from './loading/WithLoadingPromise.vue'
import { nextTick, ref } from 'vue'
import useNOIRLabArchives from '@/js/composables/useNOIRLabArchives'
import { releasesApi } from '@/js/api'
import { ReleaseMini } from '@/js/api-client'

interface Props {
  count?: number
  program: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselNews',
  props: {
    count: { default: 3 },
    program: null
  },
  setup(__props: any) {

const props = __props as { count: number, program: string };



const news = ref<ReleaseMini[]>([])
const { formatDate } = useNOIRLabArchives()

async function loadNews() {
  const { data } = await releasesApi.releasesList({ program: props.program })
  news.value = data.results?.slice(0, props.count) || []
  setTimeout(() => {
    window.initPageSliders()
  }, 100)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WithLoadingPromise, { "async-function": loadNews }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (newsItem) => {
          return (_openBlock(), _createElementBlock("section", {
            key: newsItem.id,
            style: _normalizeStyle({ 'background-image': `url(${newsItem.main_image.formats.wallpaper3})` }),
            class: "home-section bg-scroll bg-dark-alfa-50 light-content"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.window.gettext('News')), 1 /* TEXT */),
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(formatDate)(newsItem.release_date)), 1 /* TEXT */),
                _createElementVNode("a", {
                  href: `/news/${newsItem.id}`,
                  class: "text-decoration-none"
                }, [
                  _createElementVNode("h2", _hoisted_7, _toDisplayString(newsItem.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_6)
              ])
            ])
          ], 4 /* STYLE */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})